export interface PageSEO {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogTitle?: string;
  ogDescription?: string;
}

const BASE_URL = 'https://www.styror.com';

export const seoConfig: Record<string, PageSEO> = {
  home: {
    title: 'StyroR – Styropor Recycling & EPS Entsorgung Hamburg',
    description: 'Professionelles Styropor Recycling & EPS Entsorgung in Hamburg. StyroR verwertet Polystyrol, Airpop und HBCD-belastetes Styropor umweltgerecht.',
    keywords: 'Styropor Recycling, EPS Recycling, Styropor Entsorgung, Isolierung Recycling, Polystyrol, Airpop, HBCD Flammschutzmittel, Expandiertes Styropor recyceln, Extrudiertes Polystyrol entsorgen, Belastetes Styropor entsorgen, Hamburg',
    canonical: `${BASE_URL}/`,
  },
  modell: {
    title: 'Unser Recycling-Prozess – So funktioniert EPS Verwertung | StyroR',
    description: 'Vom Sammeln bis zur Wiederverwertung: So läuft der EPS- und Polystyrol-Recycling-Prozess bei StyroR ab – auch HBCD-belastet.',
    keywords: 'Recycling Prozess, EPS Aufbereitung, Polystyrol Verwertung, HBCD Entsorgung, Styropor Wiederverwertung, EPS Recycling Ablauf',
    canonical: `${BASE_URL}/modell/`,
  },
  kontakt: {
    title: 'Kontakt & Standort | StyroR – Jetzt Anfrage stellen',
    description: 'Erreichen Sie StyroR in Hamburg in der Rennbahnstraße 2. Jetzt Abholung oder Entsorgung anfragen!',
    keywords: 'StyroR Kontakt, Styropor Abholung, EPS Entsorgung Anfrage, Standort Hamburg, Rennbahnstraße',
    canonical: `${BASE_URL}/kontakt/`,
  },
  impressum: {
    title: 'Impressum – StyroR Recycling Management UG Hamburg',
    description: 'Impressum der StyroR – Styropor Recycling Management und Beratung UG in Hamburg. Geschäftsführer, Handelsregister, Standort und rechtliche Angaben.',
    keywords: 'StyroR Impressum, StyroR Kontaktdaten, Handelsregister Hamburg, StyroR UG',
    canonical: `${BASE_URL}/impressum/`,
  },
  datenschutz: {
    title: 'Datenschutzerklärung – StyroR',
    description: 'Datenschutzerklärung der StyroR in Hamburg. Informationen zu Cookies, Google Analytics, Datenverarbeitung und Ihren Rechten gemäß DSGVO.',
    keywords: 'StyroR Datenschutz, Datenschutzerklärung, DSGVO, Cookies, Google Analytics',
    canonical: `${BASE_URL}/datenschutz/`,
  },
};
